import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import rootReducer from './combined-reducer';

const middlewares = [thunk, logger];

const store = createStore(
  rootReducer,
  applyMiddleware(...middlewares),
);

export default store;
